import { PaginatedList } from '@/data/hubspot/types/common';
import { useHubspotCustomerKy } from '@/data/hubspot/useHubSpotKy';
import { shouldMock } from '@/lib/utils';
import { useQuery } from '@tanstack/react-query';
import { creditMemoSampleData } from '../../sample/credit-memo';
import { CreditMemoBody, CreditMemoData } from '../../types/credit-memo';

const DEFAULT_OPTIONS: CreditMemoBody = {
  sort_by: 'DESC',
  sort_col: 'CREDIT_MEMO_DATE',
  size: 10,
  page: 1,
};

function mockable() {
  return true;
}

export function useCreditMemos(options: Partial<CreditMemoBody>) {
  const ky = useHubspotCustomerKy();

  const pageBody = { ...DEFAULT_OPTIONS, ...options };

  return useQuery({
    queryKey: ['credit-memo', pageBody],
    queryFn: async () => {
      console.log(shouldMock, process.env.NEXT_PUBLIC_MOCK);
      if (shouldMock) {
        return creditMemoSampleData as unknown as PaginatedList<CreditMemoData>;
      }
      return await ky
        .get('credit-memos', {
          searchParams: pageBody,
        })
        .json<PaginatedList<CreditMemoData>>();
    },
  });
}
